var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"spinner-container",style:(_vm.style)},[_c('double-bounce',{attrs:{"background":"#F5C51E"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }